function init_girlownanim(from_php){
    if(from_php.girl_id==0 || from_php.anim_ava.length==0){
        return false;
    }
    var girl_id=from_php.girl_id,girl_name=$.takeGirlImage(girl_id);
    var main=$(".place.girlownanim");
    main.attr("data-girlname",girl_name);
    function animByPNG(){
        var anim_type="valen";
        var conf=$.takeGirlConf(from_php.girl_id,"girlownanim_png");
        conf=conf[anim_type];
        
        var ver=2;
        if(girl_name=="dora"){
            ver=4;
        }
        
        var path=_IMG_SERV+"/gfx/place/girlownanim/girls/"+girl_name+"/"+anim_type+"/anim.png?"+ver;
        var obj=main.find("#outputG");
        var filmIndexTime=_moduleTimeHandler.getNewIndex();
        obj.hide().css("background-image","url("+path+")").attr("data-anim_type",anim_type);

        main.one("myPreloaderInit",function(){

        }).one("myPreloaderEnd",function(){
            //data-belt_pos="top"
            obj.fadeIn(500);
            
            obj.css({width:conf.width+"px",height:conf.height+"px"});
            if(anim_type=="valen"){
                obj.css({"margin-left":-(intval(conf.width)/2)+"px"});
            }
            
            var step=-1,step_max=conf.clips;
            var anim_name=_mySound.playSound("girl_play");
            main.find("#girlTrigger").css({
                width:conf.width+"px",
                height:conf.height+"px",
                left:intval(obj.css("left"))+"px",
                top:intval(obj.css("top"))+"px"
            });
            _moduleTimeHandler.set(filmIndexTime,function(){
                step++;
                if(step>=step_max){
                    step=0;
                }
                obj.css("background-position","-"+(conf.width*step)+"px 0px");
            },40,function(){
                //clear
                _mySound.stopSound(anim_name);
            });

        }).myPreloader({urlArr:[path],addToLoader:0},_moduleTimeHandler);

    }

    animByPNG();
    var toHide=$("#mainButtonsBar,#mainBeltRightDownCorner");
    toHide.css("bottom","-100px");
    _moduleEvents.on("moduleClear",function(){
        toHide.removeAttr("style");
    });
}